import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'notification-permission-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-permission-popup.component.html',
})
export class NotificationPermissionPopupComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() enable = new EventEmitter<void>();

  constructor(private readonly eventLogger: EventLoggerService) {}

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent(
      'impression',
      JSON.stringify({ type: 'popup', name: 'notification-permission-popup' })
    );
  }

  onClose(): void {
    this.close.emit();
  }

  onEnable(): void {
    this.enable.emit();
  }
}
